window._ = require('lodash');
require('dotenv').config();

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

$('.notification-document-link').on('click', function () {
    $(this).remove()

    let last = false;
    $('.menu-notifications .notifications').each(function (index) {
        const val = Number($(this).text()) - 1;
        if (val <= 0) {
            $(this).hide();
            if (!last) {
                last = true;
            }
        }
        $(this).text(val);
    })

    if (last) {
        $('.notification-block').append('<div class="item"> <center>You don\'t have unread notifications.</center> </div>')
    }
});

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue'

import { ClientTable, ServerTable } from 'vue-tables-2';
Vue.use(ClientTable);
Vue.use(ServerTable);

window.moment = require('moment');
import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)

import Swal from 'vue-sweetalert2';
Vue.use(Swal)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('passport-clients', require('./components/passport/Clients.vue').default);
Vue.component('passport-authorized-clients', require('./components/passport/AuthorizedClients.vue').default);
Vue.component('passport-personal-access-tokens', require('./components/passport/PersonalAccessTokens.vue').default);
Vue.component('devices', require('./components/devices.vue').default);
Vue.component('group-documents', require('./components/group-documents.vue').default);
Vue.component('documents', require('./components/documents/list.vue').default);
Vue.component('delete-table', require('./components/delete-table.vue').default);
Vue.component('activities', require('./components/activities.vue').default);
Vue.component('users', require('./components/users.vue').default);
Vue.component('patients', require('./components/patients.vue').default);
Vue.component('events-component', require('./components/events-component.vue').default);
Vue.component('patient-requests', require('./components/patient-requests.vue').default);
Vue.component('services', require('./components/services.vue').default);
Vue.component('patient-history', require('./components/patient-history.vue').default);
Vue.component('enrollment-form', require('./components/enrollment-form.vue').default);
Vue.component('filtering-rules', require('./components/filtering-rules.vue').default);
Vue.component('v-expansion-panel-a', require('./plugins/v-expansion-panel-a').default);
Vue.component('signature-board', require('./components/signature-board').default);
Vue.component('shop-items', require('./components/shop-items').default);
Vue.component('shop-orders', require('./components/shop-orders').default);
window.bus = new Vue();

import vuetify from './plugins/vuetify'
if ($('#app').length) {
    new Vue({ vuetify }).$mount('#app');
}


window.onerror = function myErrorHandler(errorMsg, url, lineNumber) {
    $('#flash-msg-content').html(`Error message: ${errorMsg} + <br>url: ${url} + <br>line number: ${lineNumber}`);
    $('#flash-msg').show();
    return false;
}

$('#flash-close-btn').on('click', function () {
    $('#flash-msg-content').html('');
    $('#flash-msg').hide();
})

window.saveBlobAs = function (blob, name) {
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}